The algorithm for signing webhooks.

Currently, one code is defined:

- `SeekHmacSha512` indicates a HMAC SHA-512 hex digest will be attached to each request as a `Seek-Signature` header.

A webhook's signature can be used to validate that the request originated from SEEK.

Use a constant-time algorithm to validate the signature.
Regular comparison methods like the `==` operator are susceptible to timing attacks.
